import { Map as ImmutableMap, OrderedMap } from "immutable";

type TGetKey<T, K> = (value: T) => K;

export function toMapBy<T, K>(collection: Iterable<T>, byKey: TGetKey<T, K>): ImmutableMap<K, T> {
	let map: ImmutableMap<K, T> = ImmutableMap<K, T>();
	for (const value of collection) {
		const key = byKey(value);
		map = map.set(key, value);
	}
	return map;
}

export function toOrderedMapBy<T, K>(collection: Iterable<T>, byKey: TGetKey<T, K>): OrderedMap<K, T> {
	let map: OrderedMap<K, T> = OrderedMap<K, T>();
	for (const value of collection) {
		const key = byKey(value);
		map = map.set(key, value);
	}
	return map;
}

export function toGroupNativeMapBy<T, K>(collection: Iterable<T>, toKey: (value: T) => K) {
	const map = new Map<K, T[]>();
	for (const value of collection) {
		const key = toKey(value);
		const existingGroup = map.get(key) || [];
		const updatedGroup = [...existingGroup, value];
		map.set(key, updatedGroup);
	}
	return map;
}

export const toGroupMapBy = <T, K>(collection: Iterable<T>, toKey: (value: T) => K) =>
	ImmutableMap(toGroupNativeMapBy(collection, toKey));
